module.exports = __webpack_public_path__ + "img/image12.1627abad.png";